module.exports = __webpack_public_path__ + "static/media/arrow_up_green.c0af3495.png";